import * as React from 'react';
import { VtxButton, VtxIcon, VtxModal } from '@vertexinc/vtx-ui-react-component-library';
import Logging from '../Logging/Logging';
import ConfirmationModalProps from './ConfirmationModalProps.interface';
import './confirmation-modal.scss';

const customStylesInformation = {
  backgroundColor: '#E6F6FF',
  border: '1px solid #79C4FC',
};

const customStylesWarning = {
  backgroundColor: '#FFF7E6',
  border: '1px solid #FFA940',
};

const customStylesError = {
  backgroundColor: '#FFF1F0',
  border: '1px solid #FF4040',
};

const ConfirmationModal = ({
  isOpen,
  heading,
  message,
  okButtonName = 'OK',
  onOK = null,
  cancelButtonName = 'Cancel',
  onCancel = null,
  confirmationType,
}: ConfirmationModalProps): JSX.Element => {
  const onCloseDialog = (): void => {
    Logging.Info('ConfirmationModal Close');
    onCancel();
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getConfirmationStyle = (): any => {
    switch (confirmationType) {
      case 'Information':
        return customStylesInformation;
      case 'Warning':
        return customStylesWarning;
      case 'Error':
        return customStylesError;
      default:
        return customStylesInformation;
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getConfirmationIcon = (): any => {
    switch (confirmationType) {
      case 'Information':
        return 'info-circle';
      case 'Warning':
        return 'exclamation-circle';
      case 'Error':
        return 'close-circle';
      default:
        return 'info-circle';
    }
  };

  return (
    <div>
      <VtxModal
        visible={isOpen}
        onCancel={(): void => onCloseDialog()}
        width="415px"
        bodyStyle={getConfirmationStyle()}
        footer={null}
        closable={false}
      >
        <div className="confirmationContainer">
          <div className="confirmationContainerLeft">
            <VtxIcon type={getConfirmationIcon()} fontSize={28} />
          </div>
          <div className="confirmationContainerRight">
            <div className="confirmationHeading">
              {heading}
            </div>
            <div className="confirmationMessage">
              {message}
            </div>
            <div className="confirmationButtons">
              {
                onCancel && (
                  <div className="buttonItemBase">
                    <VtxButton
                      id="cancelButton"
                      onClick={onCancel}
                      type="default"
                    >
                      {cancelButtonName}
                    </VtxButton>
                  </div>
                )
              }
              {
                onOK && (
                  <div className="buttonItemBase">
                    <VtxButton
                      id="saveButton"
                      onClick={onOK}
                      type={confirmationType === 'Error' ? 'danger' : 'primary'}
                    >
                      {okButtonName}
                    </VtxButton>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </VtxModal>
    </div>
  );
};

export default ConfirmationModal;
